import { Injectable } from '@angular/core';
import { Constants } from '../constants/Constants';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {

  constructor(private configService: ConfigService) {}

  public getColor(color: string): string {
    const theme: string = this.configService.getEnvironnement();

    switch (color) {
      // Basic Colors
      case Constants.PackColor.MAIN_DARK:
        switch (theme) {
          case Constants.ENVIRONMENT_PRD_NAME_KEY: return("rgb( 63, 88,156)");
          case Constants.ENVIRONMENT_REC_NAME_KEY: return("rgb( 42,122, 78)");
          case Constants.ENVIRONMENT_INT_NAME_KEY: return("rgb(171, 89, 54)");
          case Constants.ENVIRONMENT_DEV_NAME_KEY: return("rgb(92,109,112)");
        } break;

      case Constants.PackColor.MAIN_LIGHT:
        switch (theme) {
          case Constants.ENVIRONMENT_PRD_NAME_KEY: return("rgb( 47,160,253)");
          case Constants.ENVIRONMENT_REC_NAME_KEY: return("rgb( 38,183,113)");
          case Constants.ENVIRONMENT_INT_NAME_KEY: return("rgb(235,148, 86)");
          case Constants.ENVIRONMENT_DEV_NAME_KEY: return("rgb(152,169,172)");
        } break;

      // Sidebar colors
      case Constants.PackColor.SIDEBAR_DARK:
        switch (theme) {
          case Constants.ENVIRONMENT_PRD_NAME_KEY: return("rgb( 47, 50, 76)");
          case Constants.ENVIRONMENT_REC_NAME_KEY: return("rgb( 41, 74, 56)");
          case Constants.ENVIRONMENT_INT_NAME_KEY: return("rgb( 99, 43, 35)");
          case Constants.ENVIRONMENT_DEV_NAME_KEY: return("rgb(60,70,72)");
        } break;

      case Constants.PackColor.SIDEBAR_LIGHT:
        switch (theme) {
          case Constants.ENVIRONMENT_PRD_NAME_KEY: return("rgb( 75, 80,121)");
          case Constants.ENVIRONMENT_REC_NAME_KEY: return("rgb( 75, 80,121)");
          case Constants.ENVIRONMENT_INT_NAME_KEY: return("rgb(141, 71, 54)");
          case Constants.ENVIRONMENT_DEV_NAME_KEY: return("rgb(100,115,118)");
        } break;

      // List colors
      case Constants.PackColor.LIST_DARK:
        switch (theme) {
          case Constants.ENVIRONMENT_PRD_NAME_KEY: return("rgb( 63, 88,156)");
          case Constants.ENVIRONMENT_REC_NAME_KEY: return("rgb(73,128, 91)");
          case Constants.ENVIRONMENT_INT_NAME_KEY: return("rgb(171, 89, 54)");
          case Constants.ENVIRONMENT_DEV_NAME_KEY: return("rgb(80,95,98)");
        } break;

      case Constants.PackColor.LIST_LIGHT:
        switch (theme) {
          case Constants.ENVIRONMENT_PRD_NAME_KEY: return("rgb(168,216,255)");
          case Constants.ENVIRONMENT_REC_NAME_KEY: return("rgb(183,235,186)");
          case Constants.ENVIRONMENT_INT_NAME_KEY: return("rgb(246,209,174)");
          case Constants.ENVIRONMENT_DEV_NAME_KEY: return("rgb(200,210,212)");
        } break;

      case Constants.PackColor.LIST_ALT_DARK:
        switch (theme) {
          case Constants.ENVIRONMENT_PRD_NAME_KEY: return("rgb( 38, 61,124)");
          case Constants.ENVIRONMENT_REC_NAME_KEY: return("rgb( 42,102, 66)");
          case Constants.ENVIRONMENT_INT_NAME_KEY: return("rgb(171, 54, 54)");
          case Constants.ENVIRONMENT_DEV_NAME_KEY: return("rgb(70,85,88)");
        } break;

      case Constants.PackColor.LIST_ALT_LIGHT:
        switch (theme) {
          case Constants.ENVIRONMENT_PRD_NAME_KEY: return("rgb(166,190,255)");
          case Constants.ENVIRONMENT_REC_NAME_KEY: return("rgb(162,224,186)");
          case Constants.ENVIRONMENT_INT_NAME_KEY: return("rgb(252,185,168)");
          case Constants.ENVIRONMENT_DEV_NAME_KEY: return("rgb(180,190,192)");
        } break;
    }
    return "";
  }
}
